import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, BookOpen, Image } from "lucide-react";
import { useAuth } from "../../app/providers/AuthProvider";
import { FK } from "../../capabilities/featureKeys";

export default function AiAnswerContentNav({ current }) {
  const { can, hasAllAccess } = useAuth() || {};
  const allowed = codes => hasAllAccess || (typeof can === "function" && codes.every(code => can(code)));
  const resources = [
    { key: "knowledge", label: "Knowledge sources", icon: BookOpen, path: "/app/ai-agent/knowledge", permissions: [FK.AI_KNOWLEDGE_VIEW] },
    { key: "media", label: "Approved media", icon: Image, path: "/app/ai-agent/media-assets", permissions: [FK.AI_MEDIA_ASSETS_VIEW] },
  ];
  return <div className="border-b border-slate-200 bg-slate-50 px-5 pt-3">
    <div className="mb-3 flex items-center justify-between gap-3 text-xs">
      {allowed([FK.AI_AGENT_SETTINGS_VIEW]) ? <Link to="/app/ai-agent/settings?section=knowledge" className="inline-flex items-center gap-1.5 text-slate-600 hover:text-slate-900"><ArrowLeft aria-hidden="true" className="h-3.5 w-3.5" />Back to setup</Link> : <span>Business knowledge</span>}
      {allowed([FK.AI_AGENT_ENABLED, FK.AI_TEST_CONSOLE_USE]) ? <Link to="/app/ai-agent/test" className="inline-flex items-center gap-1.5 text-slate-600 hover:text-slate-900">Test saved knowledge<ArrowRight aria-hidden="true" className="h-3.5 w-3.5" /></Link> : null}
    </div>
    <nav aria-label="Business knowledge resources" className="flex flex-wrap gap-x-5">
      {resources.filter(item => allowed(item.permissions)).map(item => <Link key={item.key} to={item.path}
        aria-current={current === item.key ? "page" : undefined}
        className={`inline-flex items-center gap-2 border-b-2 px-1 pb-3 text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-600 ${current === item.key ? "border-emerald-600 font-medium text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
        <item.icon aria-hidden="true" className="h-4 w-4" />{item.label}
      </Link>)}
    </nav>
  </div>;
}
